import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  SustainabilityActionTypes,
  SustainabilityActionsUnion
} from '@core/actions/sustainability.action';
import { Provider } from '@app/models';

export interface State extends EntityState<Provider> {
  loading: boolean;
  loaded: boolean;
  selectedId: any;
  isBusy: boolean;
  providersData: any;
  spinnerMessage: any;
  changes: any;
}

export const adapter: EntityAdapter<Provider> = createEntityAdapter<Provider>({
  selectId: (provider: Provider) => provider.id,
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  isBusy: false,
  selectedId: [],
  providersData: [],
  spinnerMessage: null,
  changes: []
});

export function reducer(
  state: State = INITIAL_STATE,
  action: SustainabilityActionsUnion
) {
  switch (action.type) {
    case SustainabilityActionTypes.LoadFollowParents:
    case SustainabilityActionTypes.LoadProvidersByParentId:
    case SustainabilityActionTypes.ExportByProviderId:
    case SustainabilityActionTypes.AcceptedChanges:
    case SustainabilityActionTypes.ExportGroup:
    case SustainabilityActionTypes.GetLink:
      return { ...state, loading: true, isBusy: true };

    case SustainabilityActionTypes.ExportGroupPending:
    case SustainabilityActionTypes.UploadingGroupPending:
      return { ...state, loading: true, isBusy: true, spinnerMessage: action.data.message };

    case SustainabilityActionTypes.LoadProvidersByParentIdFail:
    case SustainabilityActionTypes.ExportByProviderIdFail:
    case SustainabilityActionTypes.LoadFollowParentsFail:
    case SustainabilityActionTypes.AcceptedChangesFail:
    case SustainabilityActionTypes.ExportGroupFail:
    case SustainabilityActionTypes.ExportGroupDownloadFail:
    case SustainabilityActionTypes.UploadingGroupFail:
      return { ...state, loading: false, isBusy: false };

    case SustainabilityActionTypes.ExportByProviderIdSuccess:
    case SustainabilityActionTypes.ExportGroupDownloadSuccess:
    case SustainabilityActionTypes.UploadingGroupSuccess:
      return { 
        ...state, 
        loading: false, 
        loaded: true, 
        isBusy: false 
      };

    case SustainabilityActionTypes.LoadFollowParentsSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        selectedId: action.data
      };

    case SustainabilityActionTypes.LoadProvidersByParentIdSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        providersData: action.data
      };

    case SustainabilityActionTypes.UploadProcessFile:
      return { 
        ...state,
        loaded: false,
        loading: true,
        isBusy: true,
        spinnerMessage: 'Buscando Cambios...'
      };

    case SustainabilityActionTypes.UploadProcessFileSuccess:
      return { 
        ...state,
        loaded: true,
        loading: false,
        isBusy: false,
        spinnerMessage: null,
        changes: action.data.changes
      };

    case SustainabilityActionTypes.ClearState:
      return INITIAL_STATE

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const getState = createFeatureSelector<State>('sustainability');

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectSelectedId = (state: State) => state.selectedId;
export const selectProvidersData = (state: State) => state.providersData;
export const selectIsBusy = (state: State) => state.isBusy;
export const selectSpinnerMessage = (state: State) => state.spinnerMessage;
export const selectChanges = (state: State) => state.changes

export const getFollowParents = createSelector(
    getState,
    selectSelectedId
);

export const getProvidersData = createSelector(
  getState,
  selectProvidersData
);

export const getisBusy = createSelector(
  getState,
  selectIsBusy
)

export const getSpinnerMessage = createSelector(
  getState,
  selectSpinnerMessage
)

export const getChanges = createSelector(
  getState,
  selectChanges
)

